/**
 * Legend Component
 * Displays the color coding legend for different historical eras
 */

export default function Legend() {
  return (
    <div className="mt-6 text-xs text-gray-600 flex flex-wrap items-center gap-2">
      <span className="font-medium">Color by era:</span>
      <span className="inline-flex items-center gap-1">
        <span className="w-3 h-3 inline-block rounded bg-emerald-600"/>
        pre–1600
      </span>
      <span className="inline-flex items-center gap-1">
        <span className="w-3 h-3 inline-block rounded bg-indigo-600"/>
        1600–1867 (Edo)
      </span>
      <span className="inline-flex items-center gap-1">
        <span className="w-3 h-3 inline-block rounded bg-rose-600"/>
        1868–1945
      </span>
      <span className="inline-flex items-center gap-1">
        <span className="w-3 h-3 inline-block rounded bg-amber-600"/>
        1946–present
      </span>
      <span className="ml-4">Unknown years are shown as dotted markers.</span>
    </div>
  );
}